import { useState } from "react";
import { useLayouts } from "../LayoutsProvider";
import NoLayout from "./NoLayout";
import BoxPreview from "./BoxPreview";
import { BoxSkeleton } from './SkeletonsLayout';

const NotFoundLayout = () => {
  const { loading, layouts } = useLayouts();

  if (loading) return <BoxSkeleton />;

  let notFoundLayouts = [];

  if (layouts.length > 0) {
    layouts.map((current, index) => {
      if (current.layout_value === "404-page") notFoundLayouts.push(current);
    });
  }

  if (layouts.length > 0 && notFoundLayouts.length > 0) {
    return <BoxPreview source="404" layout={notFoundLayouts} />;
  }

  return <NoLayout source="404-page" />;
};

export default NotFoundLayout;
